<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/empresa', query: $route.query }"> Cadastro/Empresa </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <v-container fluid>
      <v-row class="text-center">
        <v-col cols="12">
          <div class="float-right">
            <imagem ref="imagem" :styleTile="true" :title="title" :isAllowed="!readOnly" />
          </div>
        </v-col>
      </v-row>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col cols="12" sm="12">
            <v-text-field
              label="Empresa *"
              v-model="nome"
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Empresa é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" sm="4">
            <v-text-field
              label="CNPC/CPF *"
              v-model="cpf_cnpj"
              v-mask="['###.###.###-##', '##.###.###/####-##']"
              :counter="18"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O preenchimento do CPF/CNPJ é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="Telefone *"
              v-model="telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :counter="15"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O Telefone é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              label="IE *"
              v-model="inscricaoEstadual"
              :counter="100"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'A Inscrição Estadual é obrigatória']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <endereco ref="endereco" :isAllowed="readOnly" />
      </v-form>
      <v-row align="center">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="empresa.ativo"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn :to="{ path: '/empresa', query: $route.query }" color="error" class="mr-4" v-if="!readOnly"> Voltar </v-btn>
          <v-btn :to="{ path: '/empresa', query: $route.query }" color="success" class="mr-4" v-else> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { editarEmpresaAsync } from "../../../services/empresaService";
import { mapState } from "vuex";
import Imagem from "../../Avatar/AvatarCard";
import Endereco from "../Endereco";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarEmpresa",
  data: () => ({
    overlay: false,
    valid: true,
    title: "Upload Imagem",
    nome: null,
    cpf_cnpj: null,
    inscricaoEstadual: null,
    telefone: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("empresa", ["empresa"]),
  },
  methods: {
    async enviar() {
      var enderecoValido = this.$refs.endereco.updateObjectEstate();
      if (this.$refs.form.validate() && enderecoValido) {
        this.overlay = true;
        var img = this.$refs.imagem.getImg();
        const resposta = await editarEmpresaAsync(
          this.empresa.id,
          this.nome,
          this.cpf_cnpj,
          this.inscricaoEstadual,
          this.telefone,
          this.$refs.endereco.cep,
          this.$refs.endereco.logradouro,
          this.$refs.endereco.numero,
          this.$refs.endereco.complemento,
          this.$refs.endereco.bairro,
          this.$refs.endereco.cidade,
          this.$refs.endereco.uf,
          img,
          this.empresa.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Descupe, falha na operação!", "error");
        } else {
          /*this.$fire({
            text: "Usuário editado com sucesso",
            type: "success",
            timer: 3000,
          });*/
          this.overlay = false;
          this.$router.push({ path: '/empresa', query: this.$route.query });
        }
      }
    },
  },
  created: function () {
    this.nome = this.empresa.nome;
    this.cpf_cnpj = this.empresa.cpf_cnpj;
    this.inscricaoEstadual = this.empresa.inscricaoEstadual;
    this.telefone = this.empresa.telefone;
  },
  mounted() {
    this.readOnly = !getUserPermission(2);
    var endereco = new Object();
    endereco.cep = this.empresa.cep;
    endereco.logradouro = this.empresa.endereco;
    endereco.numero = this.empresa.numero;
    endereco.complemento = this.empresa.complemento;
    endereco.bairro = this.empresa.bairro;
    endereco.cidade = this.empresa.cidade;
    endereco.uf = this.empresa.uf;
    this.$refs.endereco.updateObject2(endereco);
    if (this.empresa.logo) {
      this.$refs.imagem.setImg(this.empresa.logo);
    }
  },
  components: {
    Imagem,
    Endereco,
  },
};
</script>